{
  "sidebar": {
    "nav": {
      "home": "Home",
      "events": "Events & Reservations",
      "notifications": "Notifications",
      "chats": "Chats",
      "explore": "Explore",
      "venueSearch": "Venue Search",
      "discover": "Discover",
      "lists": "Your Lists",
      "newChat": "New chat"
    },
    "recentConversations": "Recent Conversations",
    "seeMore": "See more",
    "loadingMore": "Loading more",
    "newChatFallback": "New Chat",
    "expand": "Expand",
    "collapse": "Collapse",
    "earnAndeRewards": "Earn Ande Rewards",
    "redeemAndeRewards": "Redeem Ande Rewards"
  },
  "hero": {
    "welcome": "Welcome",
    "greeting": {
      "goodMorning": "Good morning",
      "goodAfternoon": "Good afternoon",
      "goodEvening": "Good evening",
      "withName": "{{greeting}}, {{firstName}}",
      "leadOnly": "{{greeting}}"
    },
    "ai": {
      "promptLead": "What shall we",
      "rotatingWords": {
        "host": "host",
        "cater": "cater",
        "plan": "plan",
        "toast": "toast",
        "book": "book",
        "explore": "explore"
      }
    },
    "classic": {
      "searchStartsHere": "your search starts here."
    }
  },
  "modeToggle": {
    "classic": "Classic",
    "andeAiBeta": "Ande AI BETA"
  },
  "aiEntry": {
    "placeholder": "Tell Ande what you're planning — a client dinner, an offsite lunch, a team happy hour...",
    "askAndeAria": "Ask Ande",
    "defaultSuggestions": {
      "findDining": "Find a dining option",
      "bookTonight": "Book a table for tonight",
      "findCaterer": "Find a caterer"
    }
  },
  "assistantPrompts": {
    "home": {
      "dining_help": {
        "title": "Help me find a dining option",
        "description": "Ask Ande for dining ideas based on team size, timing, or neighborhood"
      },
      "upcoming_events": {
        "title": "Show me the events I have coming up",
        "description": "Get a quick snapshot of your upcoming schedule and what needs attention"
      },
      "upcoming_reservations": {
        "title": "Review my upcoming reservations",
        "description": "See what is booked next and call out important reservation details"
      },
      "event_summary": {
        "title": "Summarize my active events and next steps",
        "description": "Catch up on planning progress, blockers, and the most important follow-ups"
      }
    },
    "ai": {
      "dining_help": {
        "title": "Help me find a dining option",
        "description": "Ask Ande for dining ideas based on team size, timing, or neighborhood"
      },
      "upcoming_events": {
        "title": "Show me the events I have coming up",
        "description": "Get a quick snapshot of your upcoming schedule and what needs attention"
      },
      "upcoming_reservations": {
        "title": "Review my upcoming reservations",
        "description": "See what is booked next and call out important reservation details"
      },
      "event_summary": {
        "title": "Summarize my active events and next steps",
        "description": "Catch up on planning progress, blockers, and the most important follow-ups"
      },
      "dining_option_for_event": {
        "title": "Help me find a dining option for this event"
      }
    },
    "chats": {
      "inquire": {
        "title": "Inquire for you",
        "description": "The concierge messages venues, chases replies and brings back availability.",
        "example": "Ask all four about October 2"
      },
      "create_event": {
        "title": "Turn it into an event",
        "description": "When research firms up, the chat becomes an event with guests and a booked room.",
        "example": "Create an event from this"
      },
      "spend_policy": {
        "title": "Keep spend in policy",
        "description": "Attach a PO, check the per-person cap and settle on the House Account.",
        "example": "Is $250 pp within policy?"
      }
    },
    "venues": {
      "show_details": {
        "title": "Show me the details of {{ venue_name }}",
        "description": "Get a quick snapshot of the venue details and what needs attention"
      },
      "show_awards": {
        "title": "Show awards for {{ venue_name }}",
        "description": "Get the top information about the venue awards and recognition"
      },
      "show_menu": {
        "title": "Show me the menu for {{ venue_name }}",
        "description": "Get the full menu for the venue"
      },
      "book_reservation": {
        "title": "Book {{ venue_name }}",
        "description": "Get a table now for your upcoming event"
      }
    }
  },
  "serviceTeam": {
    "ariaLabel": "Ande Service Team",
    "title": "Ande Service Team",
    "description": "We'll find venues, confirm bookings, and handle payments.",
    "request": "Request",
    "pay": "Pay"
  },
  "loadingModal": {
    "title": "Checking availability...",
    "steps": {
      "discover": "Discover",
      "book": "Book",
      "finalize": "Finalize"
    },
    "venueImageAlt": "Venue {{number}}"
  },
  "recentSearches": {
    "label": "Recent\u00a0Searches:",
    "partyOf": "Party of {{partySize}}"
  },
  "industryFavorites": {
    "title": "Top Picks by Industry",
    "description": "Explore industry favorites"
  },
  "clientStatus": {
    "message": "Please check back later.",
    "inactive": {
      "title": "Your Client is Inactive"
    },
    "implementation": {
      "title": "Your Client is in Implementation"
    }
  },
  "conciergePay": {
    "paymentMethodRequired": "Please add a payment method to continue.",
    "toasts": {
      "billingUnavailable": "Vendor payments aren't set up for your team yet.",
      "formUnavailable": "Concierge Pay isn't available on Home for your account."
    }
  },
  "chatsIndex": {
    "title": "Chats",
    "introSubtitle": "Every conversation with the concierge lives here — the ones that become events, and the ones that stay research.",
    "newChat": "New Chat",
    "searchPlaceholder": "Search chats, events, venues",
    "clearSearchAria": "Clear search",
    "previewIntroAria": "Preview empty-state intro",
    "devToggle": {
      "intro": "Intro",
      "list": "List"
    },
    "filters": {
      "all": "All",
      "research": "Research",
      "linkedToEvent": "Linked To An Event",
      "archived": "Archived"
    },
    "empty": {
      "noSearchResults": "No chats match “{{query}}”",
      "research": "No research conversations.",
      "linkedToEvent": "No conversations linked to an event.",
      "archived": "Nothing archived yet.",
      "default": "No conversations yet."
    },
    "countLine": {
      "archived_one": "{{count}} archived conversation",
      "archived_other": "{{count}} archived conversations",
      "summary_one": "{{count}} conversation · {{research}} research · {{linked}} linked to an event",
      "summary_other": "{{count}} conversations · {{research}} research · {{linked}} linked to an event"
    },
    "notifications": {
      "rename": {
        "success": {
          "title": "Chat renamed",
          "body": "The chat has been renamed"
        },
        "failed": {
          "title": "Failed to rename chat",
          "body": "Failed to rename chat"
        }
      },
      "archive": {
        "success": {
          "title": "Chat archived",
          "body": "The chat has been archived"
        },
        "failed": {
          "title": "Failed to archive chat",
          "body": "Failed to archive chat"
        },
        "invalid": {
          "title": "Failed to archive chat",
          "body": "Invalid archive request"
        }
      },
      "unknownAction": "Unknown action"
    },
    "statusPills": {
      "research": "Research",
      "planning": "Planning",
      "optionsAvailable": "Options Available",
      "confirmed": "Confirmed",
      "completed": "Completed",
      "archived": "Archived"
    },
    "researchPurpose": {
      "EXPLORING_VENUES": "Exploring Venues",
      "POLICY_COMPLIANCE": "Policy & compliance",
      "GENERAL": "General"
    },
    "row": {
      "noMessagesYet": "No messages yet",
      "openChatAria": "Open chat {{title}}",
      "chatActionsAria": "Chat actions",
      "rename": "Rename",
      "archive": "Archive",
      "archiveConfirmTitle": "Are you sure?",
      "archiveConfirmButton": "Yes, archive chat",
      "archiveWithEventBody": "This will permanently archive the chat and its linked event.",
      "archiveBody": "This will permanently archive the chat.",
      "archiveCannotUndo": "This action cannot be undone.",
      "linkedToEventFallback": "Linked to an event",
      "defaultTitle": "New Chat",
      "renameFailed": "Failed to rename chat"
    }
  },
  "aiPortal": {
    "loadingAria": "Loading Ande AI",
    "closeOverlayAria": "Close Ande AI",
    "fullscreenAria": "Go to Fullscreen Chat View",
    "closeAria": "Close"
  },
  "notifications": {
    "rewardsEnabled": {
      "title": "Success!",
      "body": "Your account has been enabled for rewards."
    },
    "smsPreferencesError": {
      "title": "Error",
      "body": "Failed to update SMS preferences. Please try again later."
    },
    "offerDeclined": {
      "title": "Success",
      "body": "The offer has been declined"
    },
    "offerDeclineError": {
      "title": "Error",
      "body": "There was an issue declining the offer. Please try again later."
    }
  },
  "curated": {
    "ariaLabel": "Discover Venues — curated collections for every kind of event",
    "eyebrow": "Curated for you",
    "title": "Need some inspiration?",
    "body": "Curated collections for every kind of event — from rooftop dinners to all-day offsites.",
    "discoverVenues": "Discover Venues",
    "venueImageAlt": "Venue"
  },
  "upcomingEvents": {
    "sectionTitle": "Your Upcoming Events",
    "emptyEyebrow": "Your Upcoming Events",
    "emptyTitle": "Nothing on the calendar yet.",
    "emptyBody": "You don't have any upcoming events. Let's create one!",
    "newEvent": "New Event",
    "uploadCalendar": "Upload Events Calendar",
    "seeAll": "See All Events",
    "add": "Add",
    "createNew": "Create New",
    "tableAria": "Upcoming events",
    "eventName": "Event Name",
    "type": "Type",
    "status": "Status",
    "continue": "Continue",
    "view": "View",
    "planning": "Planning",
    "confirmed": "Confirmed",
    "guest_one": "guest",
    "guest_other": "guests",
    "reservationFallback": "Reservation"
  },
  "pendingApprovals": {
    "sectionTitle": "Pending Approvals",
    "seeAll": "See All Approvals",
    "seeAllInline": "See all approvals",
    "summary_one": "You have {{count}} pending approval.",
    "summary_other": "You have {{count}} pending approvals.",
    "tableAria": "Pending approvals",
    "emptyListHint": "Open approvals to view the full list and take action.",
    "noneOnHome": "You don't have any pending approvals.",
    "requestedBy": "Requested by {{name}}",
    "columns": {
      "event": "Event",
      "purchaseOrder": "Purchase Order",
      "poBalance": "PO Balance",
      "requestedBudget": "Requested Budget"
    },
    "review": "Review"
  },
  "rewards": {
    "boostPill": {
      "title": "Rewards Boost"
    },
    "andeRewards": "Ande Rewards",
    "learnMore": "Learn more",
    "redeemNow": "Redeem now",
    "unlockTitle": "Unlock rewards.",
    "unlockBody": "Earn Ande Rewards with every completed reservation. Redeemable as personal gift cards.",
    "pendingAmount": "+ {{amount}} pending",
    "illustrationEventTitle": "Team Dinner",
    "legacy": {
      "level": "LEVEL",
      "andeRewards": "Ande Rewards",
      "pointsExpiryTooltip": "Complete your reservations before {{expiryDate}}. Points expire every month.",
      "pointsDenomSm": " pts",
      "browseVenues": "Browse Venues",
      "cardProgress": "You're <points>{{pointsRemaining}} {{pointsLabel}}</points> from a <reward>{{rewardAmount}} gift card.</reward>",
      "bannerProgress": "You're <points>{{pointsRemaining}} {{pointsLabel}}</points> away from a <reward>{{rewardAmount}} gift card.</reward>",
      "point_one": "point",
      "point_other": "points",
      "resets": "Resets {{date}}",
      "unclaimedShort": "You have unclaimed rewards",
      "claim": "Claim",
      "learnAboutRewards": "Learn about rewards",
      "unclaimedBannerTitle": "Also, you have unclaimed rewards",
      "unclaimedBannerBody": "Don't forget to claim them before they expire.",
      "claimRewards": "Claim Rewards",
      "milestoneGiftCard": "gift card",
      "milestoneCredit": "credit",
      "milestonePts": "{{pts}} PTS"
    }
  },
  "explore": {
    "sectionLabel": "OR EXPLORE OPTIONS",
    "chooseLocation": "Choose a location",
    "ariaExploreOptions": "Explore options",
    "startRequest": "Start a request",
    "thisCity": "this city",
    "fulfilledByService": "Fulfilled by service",
    "hoverCta": {
      "explore": "Explore →",
      "request": "Request →"
    },
    "subtitle": {
      "explore": "Explore {{noun}} in {{cityLabel}}",
      "floor": "{{displayCount}}+ {{noun}} in {{cityLabel}}"
    },
    "demoBookingMeta_one": "Recently arranged · {{count}} guest · {{city}}",
    "demoBookingMeta_other": "Recently arranged · {{count}} guests · {{city}}",
    "interstitial": {
      "title": "{{interstitialTitleNoun}} in {{cityLabel}}? Our service team is on it."
    },
    "cards": {
      "DINING": {
        "title": "Dining",
        "noun": "venues",
        "imageAlt": "Dining",
        "interstitialTitleNoun": "Dining",
        "interstitialBody": "We don't list dining in {{cityLabel}} yet, but Ande's service team works with trusted local partners and books directly — within your budget and policy, like any other reservation.",
        "inventorySubtitleExact_one": "{{count}} venue in {{cityLabel}}",
        "inventorySubtitleExact_other": "{{count}} venues in {{cityLabel}}",
        "demoBookings": {
          "client-dinner-quiet-corner": { "quote": "Client dinner at a quiet corner table" },
          "team-celebration-tasting": { "quote": "Team celebration tasting menu" },
          "recruiting-lunch": { "quote": "Last-minute recruiting lunch" }
        }
      },
      "CATERING": {
        "title": "Catering",
        "noun": "caterers",
        "imageAlt": "Catering",
        "interstitialTitleNoun": "Catering",
        "interstitialBody": "We don't list caterers in {{cityLabel}} yet, but Ande's service team works with trusted local caterers and books directly — breakfast spreads, plated lunches, cocktail receptions, full-service dinners — within your budget and policy, like any other reservation.",
        "inventorySubtitleExact_one": "{{count}} caterer in {{cityLabel}}",
        "inventorySubtitleExact_other": "{{count}} caterers in {{cityLabel}}",
        "demoBookings": {
          "game-day-watch-party": { "quote": "Game-day watch party spread" },
          "offsite-breakfast": { "quote": "Breakfast for the offsite kickoff" },
          "client-cocktail-reception": { "quote": "Cocktail reception for visiting clients" }
        }
      },
      "EXPERIENCES": {
        "title": "Experiences",
        "noun": "experiences",
        "imageAlt": "Experiences",
        "interstitialTitleNoun": "Experiences",
        "interstitialBody": "We don't list experiences in {{cityLabel}} yet, but Ande's service team works with trusted local partners and books directly — sushi-rolling classes, wine tastings, barista pop-ups, chef-led demos — within your budget and policy, like any other reservation.",
        "inventorySubtitleExact_one": "{{count}} experience in {{cityLabel}}",
        "inventorySubtitleExact_other": "{{count}} experiences in {{cityLabel}}",
        "demoBookings": {
          "sushi-rolling-offsite": { "quote": "Sushi-rolling class for the product offsite" },
          "office-kitchen-tasting": { "quote": "Chef-led tasting in the office kitchen" },
          "wine-tasting-all-hands": { "quote": "Wine tasting after the all-hands" }
        }
      },
      "SPORTS": {
        "title": "Sports and Live Events",
        "noun": "events",
        "imageAlt": "Sports and live events",
        "interstitialTitleNoun": "Sports and live events",
        "interstitialBody": "We don't list sports and live events in {{cityLabel}} yet, but Ande's service team works with trusted local partners and books tickets and hospitality — within your budget and policy.",
        "inventorySubtitleExact_one": "{{count}} event in {{cityLabel}}",
        "inventorySubtitleExact_other": "{{count}} events in {{cityLabel}}",
        "demoBookings": {
          "rivalry-night-suite": { "quote": "Suite for the rivalry night" },
          "open-client-hospitality": { "quote": "Client hospitality at the Open" },
          "home-opener-outing": { "quote": "Team outing to the home opener" }
        }
      },
      "MERCHANDISING": {
        "title": "Merchandising",
        "noun": "items",
        "imageAlt": "Merchandising",
        "interstitialTitleNoun": "Merchandising",
        "interstitialBody": "We don't list merchandising in {{cityLabel}} yet, but Ande's service team works with trusted local partners for branded swag and gifting — within your budget and policy.",
        "inventorySubtitleExact_one": "{{count}} item in {{cityLabel}}",
        "inventorySubtitleExact_other": "{{count}} items in {{cityLabel}}",
        "demoBookings": {
          "launch-week-swag": { "quote": "Launch-week swag kits" },
          "q4-client-gifting": { "quote": "Client gifting for the Q4 dinner" },
          "new-hire-welcome-boxes": { "quote": "Branded welcome boxes for new hires" }
        }
      }
    }
  },
  "searchForm": {
    "eventDetails": "Event Details",
    "listingCategory": "Listing Category",
    "where": "Where",
    "when": "When",
    "duration": "Duration",
    "eventType": "Event Type",
    "eventPolicy": "Event Policy",
    "search": "Search",
    "selectDateAndTime": "Select Date & Time",
    "selectLocation": "Select location",
    "selectEventType": "Select Event Type",
    "selectEventPolicy": "Select Event Policy",
    "selectADate": "Select a Date",
    "loading": "Loading...",
    "currentLocation": "Current Location",
    "delivery": "Delivery",
    "pickup": "Pickup",
    "guest": "Guest",
    "guest": "Guest",
    "attendee": "Attendee",
    "partySizeDisplay_guests_one": "{{count}} Guest",
    "partySizeDisplay_guests_other": "{{count}} Guests",
    "partySizeDisplay_attendees_one": "{{count}} Attendee",
    "partySizeDisplay_attendees_other": "{{count}} Attendees",
    "addGuests": "Add Guests",
    "addAttendees": "Add Attendees",
    "durationMinutes": "{{minutes}}m",
    "calendar": {
      "previousMonth": "Previous month",
      "nextMonth": "Next month"
    },
    "listingCategories": {
      "DINING": "Dining",
      "OUT_OF_OFFICE": "Team Activity",
      "CATERING": "Catering",
      "IN_OFFICE": "Office Experience"
    },
    "durationOptions": {
      "any": "Any",
      "30m": "30m",
      "1h": "1h",
      "2h": "2h",
      "3hPlus": "3h+"
    },
    "experienceTypes": {
      "ALL": "All",
      "SEATED_DINING": "Seated Dining",
      "HAPPY_HOUR": "Happy Hour",
      "COCKTAIL_RECEPTION": "Cocktail Reception",
      "RECEPTION_AND_DINING": "Reception and Dining"
    },
    "experienceTypeDetails": {
      "SEATED_DINING": {
        "title": "Seated Dining",
        "description": "A sit-down meal with full table service."
      },
      "HAPPY_HOUR": {
        "title": "Happy Hour",
        "description": "Casual gathering with drinks and light bites, typically at the bar or lounge."
      },
      "COCKTAIL_RECEPTION": {
        "title": "Cocktail Reception",
        "description": "Standing event focused on beverages and passed hors d'oeuvres."
      },
      "RECEPTION_AND_DINING": {
        "title": "Cocktail Reception + Dining",
        "description": "A cocktail reception followed by a seated dinner."
      }
    }
  },
  "listingTypes": {
    "DINING": "Dining",
    "CATERING": "Catering",
    "TEAM_ACTIVITY": "Team Activity",
    "ACTIVITY": "Activity",
    "CONCERT": "Concert",
    "DINING_ACTIVITY": "Dining Activity",
    "SPORT_EVENT": "Sport Event",
    "OTHER": "Other",
    "PAY": "Pay",
    "EVENT_SPACE": "Event Space",
    "TRANSPORTATION": "Transportation",
    "AUDIO_VISUAL": "Audio Visual",
    "ANCILLARY_VENDOR_SERVICES": "Ancillary Vendor Services",
    "MERCH": "Merch"
  },
  "industryLabels": {
    "CONSUMER_GOODS_AND_RETAIL": "Consumer Goods & Retail",
    "CONSULTING": "Consulting",
    "EDUCATION": "Education",
    "ENERGY": "Energy",
    "FASHION": "Fashion",
    "FINANCE": "Finance",
    "HEALTHCARE": "Healthcare",
    "INDUSTRIAL": "Industrial",
    "LEGAL": "Legal",
    "MEDIA": "Media",
    "NONPROFIT": "Nonprofit",
    "REAL_ESTATE": "Real Estate",
    "TECHNOLOGY": "Technology",
    "TRAVEL": "Travel"
  },
  "smsOptIn": {
    "title": "Receive reservation updates & promotional SMS from Ande",
    "phoneNumberLabel": "Your phone number",
    "decline": "No thanks",
    "accept": "I agree – Enable SMS"
  },
  "calendarUpload": {
    "title": "Import your events calendar",
    "postTitle": "Upload your events calendar and we'll automatically create and organize each event in your profile"
  },
  "eventPlanner": {
    "defaultTitle": "Start a new event",
    "eventName": "Event Name",
    "type": "Type",
    "location": "Location",
    "where": "Where",
    "currentLocation": "Current Location",
    "budgetUsd": "Budget (USD)",
    "budgetHint": "After taxes, fees & gratuity.",
    "budgetTotal": "Total",
    "budgetPerPerson": "Per Person",
    "budgetAny": "Any",
    "selectDate": "Select Date",
    "datePlaceholder": "Date",
    "guestCount": "Guest Count",
    "startTime": "Start Time",
    "selectTime": "Select time",
    "cancel": "Cancel",
    "creating": "Creating...",
    "createEvent": "Create Event"
  },
  "conciergeBooking": {
    "modal": {
      "inquiryTitle": "Service request",
      "cancellationTitle": "Cancellation Request",
      "postTitleSelfServe": "Please allow at least 24 hours for a response. We'll notify you when we hear from the restaurant.",
      "postTitleConcierge": "Please submit the form below and a dedicated service representative will reach out to you about your event.",
      "inquirySubmittedTitle": "Inquiry Submitted",
      "inquirySubmittedSelfServe": "We've added this option to your event. We'll let you know as soon as we hear back from {{venueName}}.",
      "inquirySubmittedApproval": "Once approved our team will start sourcing options for your event.",
      "inquirySubmittedConcierge": "Our team is sourcing options for your event and will update you soon.",
      "venueFallback": "the venue"
    },
    "categories": {
      "DINING": "Dining",
      "CATERING": "Catering",
      "TICKETS": "Tickets",
      "ACTIVITY": "Experiences",
      "MERCH": "Merch",
      "PAY": "Pay"
    },
    "eventTypes": {
      "SEATED_DINING": "Seated Dinner",
      "HAPPY_HOUR": "Happy Hour",
      "COCKTAIL_RECEPTION": "Cocktail Reception",
      "RECEPTION_AND_DINING": "Cocktail Reception + Seated Dinner",
      "BREAKFAST": "Breakfast",
      "LUNCH": "Lunch",
      "CATERING": "Catering",
      "TEAM_ACTIVITY": "Team Activity",
      "IN_OFFICE": "In Office Experience",
      "OUT_OF_OFFICE": "Out of Office Experience",
      "OTHER_EXPERIENCES": "Other Experiences"
    },
    "form": {
      "placeholders": {
        "time": "Time",
        "eventType": "Event Type",
        "totalBudget": "Total budget",
        "privacyLevel": "Privacy Level",
        "selectEvent": "Select an Event or Create New",
        "businessReasonExample": "Example: This request is for a crucial client meeting that is essential for business development."
      },
      "sections": {
        "contactInfo": "Contact info",
        "venue": "Venue",
        "reservationInfo": "Reservation info",
        "inquiryDetails": "Inquiry Details",
        "message": "Message",
        "addToEvent": "Add to Event",
        "linkToEvent": "Link this request to an Event",
        "whyNeeded": "Why is this needed?",
        "whyNeededBody": "Your business reason will be shared with reviewers to help them assess the request.",
        "selectSpace": "Select the space you're interested in"
      },
      "labels": {
        "dateFlexible": "Date is Flexible",
        "listing": "Listing",
        "room": "Room",
        "guests": "Guests",
        "guestCount_one": "{{count}} guest",
        "guestCount_other": "{{count}} guests",
        "saveChanges": "Save Changes",
        "edit": "Edit",
        "dropOffTo": "Drop-off to"
      },
      "privacyLevels": {
        "any": "Any",
        "fullyPrivate": "Fully Private",
        "semiPrivate": "Semi Private",
        "sharedSpace": "Shared Space",
        "entireVenue": "Entire Venue"
      },
      "events": {
        "createNew": "Create New Event",
        "noResults": "No results found",
        "nameRequired": "Event name is required",
        "planningTabHint": "Once the Inquiry is submitted, this event will be added to your Planning tab."
      },
      "submit": {
        "submitting": "Submitting...",
        "submitInquiry": "Submit Inquiry",
        "submitForApproval": "Submit for Approval",
        "submitRequest": "Submit Request",
        "inquiryBadgeAlt": "Inquiry Badge"
      },
      "detailsPlaceholder": {
        "default": "Request a specific room, menu, or add any helpful notes.",
        "venueNotFound": "Have a neighborhood, venue, or cuisine in mind? Share any details that will help us book your event.",
        "editReservation": "Request a new time, day, menu alteration, party size change, or add any helpful notes.",
        "cancelReservation": "Add details about the cancellation.",
        "editOfflineReservation": "Add details about your requested changes here.",
        "vipRequest": "Add details about your VIP request here.",
        "cateringDetails": "Request specific catering details or add any helpful notes.",
        "activityDetails": "Request specific activity details or add any helpful notes."
      },
      "payment": {
        "selectPaymentMethodHeading": "Select Payment Method",
        "paymentMethodHeading": "Payment Method",
        "selectPaymentMethodPlaceholder": "Select a payment method",
        "centralBilling": "Central Billing",
        "centralBillingNamed": "{{clientName}} Central Billing",
        "centralBillingInstrumentNamed": "{{clientName}} - Central Billing",
        "creditCard": "Credit Card",
        "addCard": "Add",
        "cardAlt": "Card",
        "bookingFeeDisclaimer": "By submitting this request, you agree to pay all restaurant fees and the non-refundable {{bookingFeePercentage}}% booking fee if your booking is accepted by the venue.",
        "bookingFeeNotChargedUntilContract": "You will not be charged until a contract is signed."
      },
      "purchaseOrder": {
        "heading": "Purchase Order Number",
        "descriptionRequest": "Select a purchase order number for your request.",
        "descriptionReadOnlyEvent": "Purchase order for this event.",
        "existingPo": "Existing PO number",
        "newPo": "New PO number",
        "noPo": "I don't have a PO number",
        "skip": "Skip",
        "noPurchaseOrdersAvailable": "No purchase orders available",
        "noPurchaseOrdersFound": "No purchase orders found",
        "selectPurchaseOrder": "Select a purchase order",
        "enterPoPlaceholder": "Enter PO number",
        "noPoNumberEntered": "No PO number entered",
        "noPoSubmitRequiresApproval": "Submitting this request will require approval.",
        "noPoReadOnlySubmitted": "This request was submitted without a PO number.",
        "downloadRequiredDocumentation": "Download Required Documentation"
      }
    },
    "inquiry": {
      "fallbacks": {
        "date": "a date",
        "time": "a time",
        "laterDate": "a later date",
        "guests": "guests",
        "experience": "an experience",
        "vendor": "the vendor",
        "game": "a game"
      },
      "budgetSentence": " Our budget is ${{amount}}.",
      "budgetWithPeriod": " Total budget is ${{amount}}.",
      "pay": {
        "message": "I would like to make a payment to {{vendorName}} for the event {{dateLabel}} at {{timeLabel}} for {{guestPhrase}}.{{amountSentence}}",
        "amountSentence": " The amount is ${{amount}}.",
        "vendorAddress": "Address: {{value}}",
        "vendorWebsite": "Website: {{value}}",
        "vendorPhone": "Phone: {{value}}",
        "vendorDetailsLine": "\nVendor details — {{details}}."
      },
      "merch": {
        "unitsPrefix_one": "{{count}} unit of ",
        "unitsPrefix_other": "{{count}} units of ",
        "defaultCategory": "branded merchandise",
        "message": "I'm looking for {{units}}{{category}}.{{budgetText}} Could you share options, pricing, and lead times?"
      },
      "catering": "I am looking for catering on {{dateLabel}} at {{timeLabel}} for {{guestPhrase}}.{{budgetSentence}}",
      "activity": "I am looking to book {{activityPhrase}} on {{dateLabel}} at {{timeLabel}} for {{guestPhrase}}.{{budgetSentence}}",
      "dateList": {
        "two": "{{first}} or {{second}}",
        "many": "{{prefix}}, or {{last}}"
      },
      "tickets": {
        "seating": {
          "suite": "a suite",
          "clubSeats": "club seats",
          "blockOfSeats": "a block of seats",
          "default": "tickets"
        },
        "preferredDays": ", ideally on a {{days}}",
        "whenFlexibleWithDates": "on {{dates}}",
        "whenFlexibleRange": "between {{start}} and {{end}}{{preferredDays}}",
        "whenFixed": "on {{date}}{{alternate}}",
        "alternateDate": " (or {{date}})",
        "growGuests": " (could grow to {{maxGuests}})",
        "budgetPerTicket": " Budget is ${{amount}} per ticket.",
        "budgetTotal": " Budget is ${{amount}} total.",
        "consideringLine": "\nDates considering: {{dates}}",
        "message": "I'm looking for {{seating}} for {{team}} {{when}} for {{guestPhrase}}{{grow}}.{{budgetText}} Could you confirm availability and pricing?{{consideringLine}}"
      }
    }
  }
}
